/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';

/** CreateAuthResetResponse — dark-roast DTO: AuthResetsMfaCodeResponseDto */
export const createAuthResetResponseSchema = z.object({ "mfaCodeCreated": z.boolean() });
export type CreateAuthResetResponse = z.infer<typeof createAuthResetResponseSchema>;
